<template>
  <div>
    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">ZbierajMonety.pl</h1>
          <h2 class="subtitle">Portal o Monetach Inwestycyjnych</h2>
        </div>
      </div>
    </section>
    <div>
      <blog-article-template
        v-for="article in articles"
        :key="article.slug"
        :article="article"
        :isMinimal="true"
      ></blog-article-template>
    </div>
  </div>
</template>

<script>
import BlogArticleTemplate from "./BlogArticleTemplate";
import articles from "../articles.json";

export default {
  name: "HomePage",
  components: {
    BlogArticleTemplate
  },
  computed: {
    articles() {
      return articles.filter(art => art.isPublic);
    }
  }
};
</script>
